// General
import "./in-app-notification.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProfileQuery } from "../../../../../services/data.service";
// Static Data
import routeConst from "../../../../../const/routeConst";
import userConst from "../../../../../const/userConst";
import pusherConst from "../../../../../const/pusherConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateInterestTab } from "../../../../../redux/store/interestStore";
import { updateShouldCallApi } from "../../../../../redux/store/userCardStore";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";
// Components
import CustomAvatar from "../../custom-avatar/custom-avatar";

const InAppNotification = (props) => {
  const {
    type,
    profilePhoto,
    profileDecorations,
    username,
    userId,
    userIdInt,
    relatedId,
  } = props;

  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();

  // Redux variables
  const isDaddy = useSelector((state) => state.user.isDaddy);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
  }, []);

  // Event Handlers | Button
  const onRedirectToConversation = () => {
    switch (type) {
      case "view_profile":
      case "favorite_user":
      case "private_photo_approve":
      // dispatch(updateShouldCallApi(true));
      // onNavigate(`${routeConst.profile.view.clearPath}${userId}`);
      // break;
      case "private_photo_request":
      // dispatch(updateInterestTab(4));
      // onNavigate(routeConst.interest.path);
      // break;
      case "live":
        // onNavigate(`${routeConst.live.liveId.clearPath}${relatedId}`);
        // break;
        dispatch(updateInterestTab(0));
        onNavigate(routeConst.interest.path);
      default:
        break;
    }
  };

  // Utility Functions
  const getInAppNotificationCopywriting = () => {
    switch (type) {
      case "view_profile":
        return t("notification.user_viewed_your_profile");
      case "favorite_user":
        return t("notification.user_favorited_you");
      case "private_photo_request":
        return t("notification.user_request_access_to_view_your_private_photo");
      case "private_photo_approve":
        return t("notification.user_approved_your_private_photo_request");
      case "text_message":
        return t("notification.user_send_you_a_message");
      case "live":
        return t("notification.user_is_live_now");
      case pusherConst.globalPusher.payloadType.notificationSubType
        .verifiedPhotoRejected:
        return t("notification.vp3_rejected");
      case pusherConst.globalPusher.payloadType.notificationSubType
        .verifiedPhotoApproved:
        return t("notification.vp3_approved");
      case pusherConst.globalPusher.payloadType.notificationSubType
        .verifiedPhotoRequestRejected:
        return t("notification.vp3_request_rejected", { username: username });
      case pusherConst.globalPusher.payloadType.notificationSubType
        .verifiedPhotoRequestApproved:
        return t("notification.vp3_request_approved", { username: username });
      case pusherConst.globalPusher.payloadType.notificationSubType
        .verifiedPhotoRequest:
        return t("notification.vp3_request", { username: username });
      default:
        break;
    }
  };

  return (
    <div id="in-app-notification-element" onClick={onRedirectToConversation}>
      <div className="padding-container">
        <div className="profile-picture-container">
          <CustomAvatar
            src={profilePhoto}
            isBlur={
              isDaddy &&
              getProfileData?.data?.membership_type ===
                userConst.membershipType.free
            }
            isLock={
              false &&
              isDaddy &&
              getProfileData?.data?.membership_type ===
                userConst.membershipType.free
            }
            profileBorder={profileDecorations?.profile_border_url}
          />
        </div>

        <div className="message-body-container">
          <div className="username">{username}</div>
          <div className="message-body">
            {getInAppNotificationCopywriting()}
          </div>
        </div>

        <div className="now-container">{t("notification.now")}</div>
      </div>
    </div>
  );
};

export default InAppNotification;
